import React, { useState } from 'react';
import { Button, Col, Row, Form, Input, Select, notification } from 'antd';
import { useTranslation } from 'react-i18next';
import { DeleteOutlined } from '@ant-design/icons';
import { useSelector, useDispatch } from 'react-redux';
import {
  UPDATE_CART,
  SET_PURCHASE,
  capitalizeFirstLetter,
  SET_DISCOUNT_CODE
} from '@redux/actions';
import { requests } from '@utils/api';
import { history } from '@redux/store';
import { ErrorHandler } from '@components/error/Error';

const { Option } = Select;

const Cart = () => {
  const { t } = useTranslation('cart');
  const dispatch = useDispatch();
  const [discountCodeValue, setDicountCodeValue] = useState('');
  const cartItems = useSelector((state: IReducerStates) => state.global.cart);
  const discountCode = useSelector((state: IReducerStates) => state.global.discountCode);

  if (discountCode) {
    // setDicountCodeValue(discountCode.code);
  }

  const getTotal = () => {
    let total = 0;

    if (cartItems) {
      cartItems.forEach((item: any) => {
        total += parseFloat(item.price);
      });
    }

    return discountCode
      ? (total - (total * discountCode.amount) / 100).toFixed(2)
      : total.toFixed(2);
  };

  const removeItem = (index: number) => {
    cartItems.splice(index, 1);
    let newCart = [].concat(cartItems);
    dispatch({
      type: UPDATE_CART,
      payload: newCart
    });
  };

  const checkout = async () => {
    let form = { items: [], code: null };

    cartItems.forEach((item: any) => {
      if (item.type === 'bundle') {
        form.items.push({
          bundle: item.id,
          dog: item.dog.id,
          secondaryDog: item.secondaryDog ? item.secondaryDog.id : null
        });
      } else {
        form.items.push({
          trick: item.id,
          dog: item.dog.id,
          secondaryDog: item.secondaryDog ? item.secondaryDog.id : null
        });
      }
    });

    if (discountCode) {
      form.code = discountCode.code;
    }

    await requests
      .post('/purchase', form)
      .then(data => {
        // todo store the purchase in store
        // dispatch to store
        dispatch({
          type: SET_PURCHASE,
          payload: data
        });
        history.push('/cart/checkout');
      })
      .catch(err => {
        ErrorHandler(err);
      });
  };

  const loading = false;

  return (
    <>
      <Row justify="center" align="top" className="mainContainer">
        <Col
          xs={22}
          sm={20}
          md={18}
          lg={16}
          xl={14}
          style={{ background: '#fff', padding: '20px' }}
        >
          <h2 className="title">{t('your_cart')}</h2>
          <table style={{ width: '100%' }}>
            <tr>
              <th style={{ maxWidth: '50px' }}>&nbsp;</th>
              <th>{t('trick')}</th>
              <th>{t('price')}</th>
              <th>&nbsp;</th>
            </tr>

            {cartItems &&
              cartItems.length > 0 &&
              cartItems.map((item: any, index: any) => (
                <tr key={index}>
                  <td style={{ maxWidth: '50px' }}>
                    <img src={item.thumb + '?s=xx-small'} />
                  </td>
                  <td>
                    <a
                      href={item.type === 'bundle' ? '/bundles/' + item.id : '/tricks/' + item.id}
                      style={{ color: '#a04cfc' }}
                    >
                      {item.name}
                    </a>

                    {item.dog && (
                      <div
                        style={{
                          lineHeight: '30px'
                        }}
                      >
                        {item.dog.thumb && (
                          <img
                            style={{
                              borderRadius: '100px',
                              float: 'left',
                              marginRight: '30px',
                              maxHeight: '30px'
                            }}
                            src={item.dog.thumb + '?s=xx-small'}
                          />
                        )}
                        {!item.dog.thumb && (
                          <img
                            style={{
                              borderRadius: '100px',
                              float: 'left',
                              marginRight: '30px',
                              maxHeight: '30px'
                            }}
                            src="/dog-placeholder.jpg"
                          />
                        )}
                        {item.dog.name}
                      </div>
                    )}

                    {item.secondaryDog && (
                      <div
                        style={{
                          lineHeight: '30px'
                        }}
                      >
                        {item.secondaryDog.thumb && (
                          <img
                            style={{
                              borderRadius: '100px',
                              float: 'left',
                              marginRight: '30px',
                              maxHeight: '30px'
                            }}
                            src={item.secondaryDog.thumb + '?s=xx-small'}
                          />
                        )}
                        {!item.secondaryDog.thumb && (
                          <img
                            style={{
                              borderRadius: '100px',
                              float: 'left',
                              marginRight: '30px',
                              maxHeight: '30px'
                            }}
                            src="/dog-placeholder.jpg"
                          />
                        )}
                        {item.secondaryDog.name}
                      </div>
                    )}
                    {/* <Select
                      defaultValue={item.dog ? item.dog.id : null}
                      style={{ width: 120 }}
                      options={myDogs.map(item => {
                        return { value: item.id, label: item.name };
                      })}
                    /> */}
                  </td>
                  <td>
                    <h3>
                      {t('gbp')}
                      {item.price}
                    </h3>
                  </td>
                  <td style={{ textAlign: 'center', margin: 'auto' }}>
                    <Button type="primary" onClick={() => removeItem(index)}>
                      <DeleteOutlined />
                    </Button>
                  </td>
                </tr>
              ))}
          </table>

          <div className="pt10">
            <Input.Group compact>
              <Input
                style={{ width: '40%' }}
                placeholder={t('discount_code')}
                defaultValue={discountCode ? discountCode.code : null}
                onChange={e => {
                  setDicountCodeValue(e.target.value);
                }}
              />
              <Button
                type="primary"
                style={{ height: '41px' }}
                onClick={async () => {
                  await requests
                    .post('/discounts/validate', { code: discountCodeValue })
                    .then(data => {
                      notification.success({
                        message: 'Success',
                        description: 'Discount has been added'
                      });
                      dispatch({
                        type: SET_DISCOUNT_CODE,
                        payload: { discountCode: data }
                      });
                      // setDicountCode(data);
                    })
                    .catch(err => {
                      notification.error({
                        message: 'Error',
                        description: 'Discount code expired or invalid, please try again.'
                      });
                      //ErrorHandler(err);
                    });
                }}
              >
                {t('apply')}
              </Button>
            </Input.Group>
          </div>

          <h2 className="price-tag-checkout">
            {t('total')} {t('gbp')}
            {getTotal()} {discountCode ? `(-${discountCode.amount}%)` : ''}
          </h2>
          <Button
            type="primary"
            onClick={() => {
              checkout();
            }}
            className="fright"
          >
            {t('checkout')}
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default Cart;
